import React from 'react'
import Combaintop from '../Components/Combaintop/Top'
import Combainbottom from '../Components/Combainbottom/Combainbottom'
import OTPVerificationforgot from '../Components/Forgototp';
function Forgototp() {
    return (
        <>
        <Combaintop/>
        <OTPVerificationforgot/>
        <Combainbottom/>
        </>
        
    )
}

export default Forgototp;
